// @ts-check
/** @typedef {import('../types').Device} Device */
import React, { useState, useEffect } from 'react';
import { client } from '../utils/apiClient';
import { useAuthContext } from '../contexts/AuthContext';
import Pagination from 'rsuite/Pagination';

import {
  Affix,
  Button,
  ButtonToolbar,
  Cascader,
  Checkbox,
  FlexboxGrid,
  IconButton,
  List,
  // Tag,
  Tooltip,
  Whisper,
} from 'rsuite';
import ScaleText from 'react-scale-text';

import {
  getControllerIconText_FROM_STRING,
  getControllerIconText,
  GetDeviceBadgeFromStatus,
  GetBadgeForversion,
  LoadingView,
} from './DisplayItems';
import { Card, Col, Grid, Flex, Bold, Badge, Icon, TabGroup, TabList, Tab } from './TremorCompat';

import {
  AddDevice,
  AddDeviceInfo,
  EditDevice,
  ExtractString,
  //  SelectManyDevices,
  ShowDeviceQR,
  ShowDeviceDeleteConfirmation,
  isDeviceInFault,
  isDeviceGood,
  isDeviceOfflineWithinDateRange,
  isDeviceOffline,
  isModelTypeSelected,
  getRecordIDFromUID,
  SelectDateRange,
  SelectItemsPerPage,
  build_fault_string,
} from './Common';

import {
  MdOutlineEdit as IconEdit,
  // MdOutlineInsertChart as IconTrends,
  // MdOutlineErrorOutline as IconError,
  // MdOutlineSpaceDashboard as IconDashboard,
  // MdRadioButtonUnchecked as IconCheck,
  MdOutlineWarningAmber as IconWarning,
  MdAdd as IconMore,
  MdRemove as IconLess,
  MdQrCode2 as IconQRCode,
  MdRefresh as IconRefresh,
  MdDelete as IconRubbish,
  MdFingerprint as IconFingerPrint,
  MdOutlineInfo as IconInfo,
  MdArchive as IconArchive,
  MdOutlineArchive as IconArchive2,
} from 'react-icons/md';
import { FaRegHandPointer as IconPoint } from 'react-icons/fa';
import { ImCheckboxUnchecked as IconUnticked, ImCheckboxChecked as IconTicked } from 'react-icons/im';
import { ImBarcode as IconBarcode } from 'react-icons/im';
// import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { COLOURS, fixedHeaderCardStyle, unfixedHeaderCardStyle, headingStyle } from '../styles';
import { GiHammerBreak as IconHammer } from 'react-icons/gi';
import {
  accessLevels,

  // APP_CONFIG,
  faults_bit_t,
  FILTER_OPTIONS,
  FIRMWARE_VERSIONS,
  RECORD_TYPES,
  // sortKeys,
  mType_label_t,
  APP_CONFIG,
} from '../constants';

import { createDevice, deleteDevice, updateDevice } from '../graphql/mutations';

import usePagination from './Pagination';
import { CollectionHooksTable } from './DevicesTable';
import { StatsView } from './StatsView';
import { UserView } from './UserAccess';
import { devLog } from '../utils/devLog';

export const selectedView_t = {
  GRID: 0,
  LIST: 1,
  STATS: 2,
  SETTINGS: 3,
};

const getModelFilterOptionsData = () => {
  let ModelFilterOptionsData;
  if (APP_CONFIG.SWC_ENABLED) {
    ModelFilterOptionsData = [
      { label: mType_label_t.AQUATEK, value: FILTER_OPTIONS.modelTypeGroupAquatek },
      { label: mType_label_t.THERALINK, value: FILTER_OPTIONS.modelTypeGroupTheralink },
      { label: mType_label_t.OASIS, value: FILTER_OPTIONS.modelTypeGroupOasis },
      { label: mType_label_t.POOLTEK, value: FILTER_OPTIONS.modelTypeGroupPoolTek },
      { label: mType_label_t.HENDEN, value: FILTER_OPTIONS.modelTypeGroupHenden },
      { label: mType_label_t.AQUALIGHT, value: FILTER_OPTIONS.modelTypeGroupAqualight },
      { label: 'SummerTime', value: FILTER_OPTIONS.modelTypeGroupSummerTime },
      { label: 'SWC', value: FILTER_OPTIONS.modelTypeGroupSWC },
    ];
  } else {
    ModelFilterOptionsData = [
      { label: mType_label_t.AQUATEK, value: FILTER_OPTIONS.modelTypeGroupAquatek },
      { label: mType_label_t.THERALINK, value: FILTER_OPTIONS.modelTypeGroupTheralink },
      { label: mType_label_t.OASIS, value: FILTER_OPTIONS.modelTypeGroupOasis },
      { label: mType_label_t.POOLTEK, value: FILTER_OPTIONS.modelTypeGroupPoolTek },
      { label: mType_label_t.HENDEN, value: FILTER_OPTIONS.modelTypeGroupHenden },
      { label: mType_label_t.AQUALIGHT, value: FILTER_OPTIONS.modelTypeGroupAqualight },
      { label: 'SummerTime', value: FILTER_OPTIONS.modelTypeGroupSummerTime },
    ];
  }
  return ModelFilterOptionsData;
};

const getFilterOptionsData = () => {
  const filterOptionsData = [
    {
      label: 'Status',
      value: FILTER_OPTIONS.statusGroup,
      children: [
        { label: 'Unknown', value: FILTER_OPTIONS.statusDeviceUnknown },
        { label: 'Offline', value: FILTER_OPTIONS.statusDeviceOffline },
        {
          label: 'Fault',
          value: FILTER_OPTIONS.statusDeviceInFault,
          children: [
            { label: 'Any', value: FILTER_OPTIONS.statusDeviceFaultsAny },
            { label: 'Internal Comms', value: FILTER_OPTIONS.statusDeviceFaultsInternalCommsIssue },
            { label: 'Therm 1 Short', value: FILTER_OPTIONS.statusDeviceFaultsTherm1ShortCircuit },
            { label: 'Therm 1 Open', value: FILTER_OPTIONS.statusDeviceFaultsTherm1OpenCircuit },
            { label: 'Therm 2 Short', value: FILTER_OPTIONS.statusDeviceFaultsTherm2ShortCircuit },
            { label: 'Therm 2 Open', value: FILTER_OPTIONS.statusDeviceFaultsTherm2OpenCircuit },
            { label: 'Pump Comms', value: FILTER_OPTIONS.statusDeviceFaultsPumpCommunicationsFault },
            { label: 'Exp 1 Fault', value: FILTER_OPTIONS.statusDeviceFaultsExpansion1Fault },
            { label: 'Exp 2 Fault', value: FILTER_OPTIONS.statusDeviceFaultsExpansion2Fault },
            { label: 'Ambient Fault', value: FILTER_OPTIONS.statusDeviceFaultsAmbientTemperatureFault },
            { label: 'pH/ORP Fault', value: FILTER_OPTIONS.statusDeviceFaultsPhOrpExpansionFault },
            { label: 'Therm 3 Short', value: FILTER_OPTIONS.statusDeviceFaultsTherm3ShortCircuit },
            { label: 'Therm 4 Open', value: FILTER_OPTIONS.statusDeviceFaultsTherm3OpenCircuit },
            { label: 'Config Error', value: FILTER_OPTIONS.statusDeviceFaultsCRCError },
            { label: 'Config 2 Error', value: FILTER_OPTIONS.statusDeviceFaultsCRC2Error },
            // { "label": "Restart", "value": FILTER_OPTIONS.statusDeviceFaultsSystemRestarted},
          ],
        },
        { label: 'Good', value: FILTER_OPTIONS.statusDeviceGood },
      ],
    },
    {
      label: 'Version',
      value: FILTER_OPTIONS.versionGroup,
      children: [
        { label: 'Not Set', value: FILTER_OPTIONS.versionUnknown },
        { label: '1.15B14', value: FILTER_OPTIONS.version115B14 },
        { label: '1.16B1', value: FILTER_OPTIONS.version116B01 },
        { label: '1.16B2', value: FILTER_OPTIONS.version116B02 },
        //   { "label": "1.15B82", "value": FILTER_OPTIONS.version115B82},
        { label: 'Beta', value: FILTER_OPTIONS.versionBeta },
      ],
    },
    {
      label: 'Model',
      value: FILTER_OPTIONS.modelTypeGroup,
      children: [
        { label: mType_label_t.AQUATEK, value: FILTER_OPTIONS.modelTypeGroupAquatek },
        { label: mType_label_t.THERALINK, value: FILTER_OPTIONS.modelTypeGroupTheralink },
        { label: mType_label_t.OASIS, value: FILTER_OPTIONS.modelTypeGroupOasis },
        { label: mType_label_t.POOLTEK, value: FILTER_OPTIONS.modelTypeGroupPoolTek },
        { label: mType_label_t.HENDEN, value: FILTER_OPTIONS.modelTypeGroupHenden },
        { label: mType_label_t.AQUALIGHT, value: FILTER_OPTIONS.modelTypeGroupAqualight },
        { label: 'SummerTime', value: FILTER_OPTIONS.modelTypeGroupSummerTime },
        { label: 'SWC', value: FILTER_OPTIONS.modelTypeGroupSWC },
      ],
    },
  ];
  return filterOptionsData;
};

export function handleEditDeviceUpdate(
  device,
  name,
  userDevName,
  modeltype,
  onUpdateDeviceName,
  onUpdateUserDeviceName,
) {
  const currentDevice = device;
  const currentName = name;
  const currentUserName = userDevName;
  if (currentDevice !== null) {
    devLog('HV handleEditDeviceUpdate Result', currentDevice, currentName, currentUserName, modeltype);

    if (currentName != undefined) {
      if (modeltype === undefined) {
        modeltype = currentDevice.modelType;
      }

      if (currentDevice.userName !== currentName || currentDevice.modelType !== modeltype) {
        onUpdateDeviceName(currentDevice.uniqueDeviceId, currentName, modeltype);

        devLog('edit: name changed', currentName, modeltype);
      }
    }

    if (currentDevice.usersDeviceName == undefined || currentDevice.usersDeviceName !== currentUserName) {
      onUpdateUserDeviceName(currentDevice.uniqueDeviceId, currentUserName);
      devLog('HV handleEditDeviceUpdate: Users Device name changed', currentUserName);
    }
  }
}

/** @param {{ theDevice: Device, rowNumber: number, accessLevel: number, onEditDevice: (device: Device) => void, onViewDevice: (uid: string) => void, onShowQRCode: (device: Device) => void, onArchiveDevice: (device: Device) => void, onDeleteDevice: (device: Device) => void }} props */
const DeviceCard = ({
  theDevice,
  rowNumber,
  accessLevel,
  onEditDevice,
  onViewDevice,
  onShowQRCode,
  onArchiveDevice,
  onDeleteDevice,
}) => {
  const [showMore, setShowMore] = useState(false);

  return (
    <Card decoration="left" decorationColor={theDevice.verColor}>
      <Grid numItemsSm={2} numItemsMd={2} numItemsLg={2} className="gap-4">
        <Flex justifyContent="start" className="gap-2">
          <Badge>
            {' '}
            <Bold> {rowNumber}</Bold>
          </Badge>
        </Flex>
        <Flex justifyContent="end" className="gap-2">
          {GetDeviceBadgeFromStatus(theDevice)}
        </Flex>
      </Grid>
      <FlexboxGrid justify="space-between" align="middle" style={{ marginTop: '12px' }}>
        <FlexboxGrid.Item as={Col} colspan={6}>
          <div className="tooltip">
            <img
              src={getControllerIconText_FROM_STRING(theDevice.modelType).icon}
              alt="Controller Icon"
              width="100"
              height="100"
            />
            <span className="tooltiptext">{theDevice.modelType}</span>
          </div>
        </FlexboxGrid.Item>
        <FlexboxGrid.Item as={Col} colspan={16}>
          <List hover size="sm">
            <List.Item>
              <Flex justifyContent="center">
                <Flex className="parentDeviceName space-x-4" justifyContent="start">
                  <ScaleText className="childDeviceName" maxFontSize={20}>
                    {theDevice.userName}
                  </ScaleText>
                </Flex>
              </Flex>
            </List.Item>
            {theDevice.usersDeviceName !== 'Undefined' && theDevice.usersDeviceName !== undefined && (
              <List.Item>
                <Flex justifyContent="center">
                  <Flex className="parentUserName space-x-4" justifyContent="start">
                    <ScaleText className="childUsersName" maxFontSize={10}>
                      {theDevice.usersDeviceName}
                    </ScaleText>
                  </Flex>
                </Flex>
              </List.Item>
            )}
            <List.Item key={1}>
              <FlexboxGrid
                align="middle"
                justify="space-between"
                style={{ fontSize: '0.9em', flexWrap: 'nowrap', gap: '8px' }}
              >
                <FlexboxGrid.Item style={{ flexShrink: 0 }}>
                  <Icon icon={IconFingerPrint} color={COLOURS.default} style={{ width: 14, height: 14 }} />
                </FlexboxGrid.Item>
                <FlexboxGrid.Item
                  style={{
                    flexShrink: 1,
                    minWidth: 0,
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis',
                  }}
                >
                  <Bold> {'UID:' + theDevice.uniqueDeviceId}</Bold>
                </FlexboxGrid.Item>

                <FlexboxGrid.Item style={{ flexShrink: 0 }}>
                  <IconButton
                    appearance="primary"
                    color="blue"
                    size="xs"
                    icon={showMore ? <IconLess /> : <IconMore />}
                    onClick={() => setShowMore(!showMore)}
                    aria-label={`${showMore ? 'Show less' : 'Show more'} details for ${theDevice.userName || theDevice.uniqueDeviceId}`}
                    aria-expanded={showMore}
                  />
                </FlexboxGrid.Item>
              </FlexboxGrid>
            </List.Item>
            {showMore && (
              <List.Item key={4}>
                <FlexboxGrid
                  align="middle"
                  justify="space-between"
                  style={{ fontSize: '0.9em', flexWrap: 'nowrap', gap: '8px' }}
                >
                  <FlexboxGrid.Item style={{ flexShrink: 0 }}>
                    <Icon icon={IconBarcode} color={COLOURS.default} style={{ width: 14, height: 14 }} />
                  </FlexboxGrid.Item>
                  <FlexboxGrid.Item
                    style={{
                      flexShrink: 1,
                      minWidth: 0,
                      overflow: 'hidden',
                      whiteSpace: 'nowrap',
                      textOverflow: 'ellipsis',
                    }}
                  >
                    {'SN:' + theDevice.serialNumber}
                  </FlexboxGrid.Item>
                </FlexboxGrid>
              </List.Item>
            )}
            {showMore && (
              <List.Item key={5}>
                <FlexboxGrid
                  align="middle"
                  justify="space-between"
                  style={{ fontSize: '0.9em', flexWrap: 'nowrap', gap: '8px' }}
                >
                  <FlexboxGrid.Item style={{ flexShrink: 0 }}>
                    <Icon icon={IconInfo} color={COLOURS.default} style={{ width: 14, height: 14 }} />
                  </FlexboxGrid.Item>
                  <FlexboxGrid.Item
                    style={{
                      flexShrink: 1,
                      minWidth: 0,
                      overflow: 'hidden',
                      whiteSpace: 'nowrap',
                      textOverflow: 'ellipsis',
                    }}
                  >
                    {GetBadgeForversion(theDevice)}
                  </FlexboxGrid.Item>
                </FlexboxGrid>
              </List.Item>
            )}
            {showMore && (
              <List.Item key={6}>
                <FlexboxGrid
                  align="middle"
                  justify="space-between"
                  style={{ fontSize: '0.9em', flexWrap: 'nowrap', gap: '8px' }}
                >
                  <FlexboxGrid.Item style={{ flexShrink: 0 }}>
                    <Icon icon={IconWarning} color={COLOURS.default} style={{ width: 14, height: 14 }} />
                  </FlexboxGrid.Item>
                  <FlexboxGrid.Item
                    style={{
                      flexShrink: 1,
                      minWidth: 0,
                      overflow: 'hidden',
                      whiteSpace: 'nowrap',
                      textOverflow: 'ellipsis',
                    }}
                  >
                    {'Faults:' + build_fault_string(theDevice.currentFaults, true, 'Nil').string}
                  </FlexboxGrid.Item>
                </FlexboxGrid>
              </List.Item>
            )}

            {showMore && (
              <List.Item key={7}>
                <FlexboxGrid
                  align="middle"
                  justify="space-between"
                  style={{ fontSize: '0.9em', flexWrap: 'nowrap', gap: '8px' }}
                >
                  <FlexboxGrid.Item style={{ flexShrink: 0 }}>
                    <Icon icon={IconHammer} color={COLOURS.default} style={{ width: 14, height: 14 }} />
                  </FlexboxGrid.Item>
                  <FlexboxGrid.Item
                    style={{
                      flexShrink: 1,
                      minWidth: 0,
                      overflow: 'hidden',
                      whiteSpace: 'nowrap',
                      textOverflow: 'ellipsis',
                    }}
                  >
                    {'Date Made:' + theDevice.dateMade}
                  </FlexboxGrid.Item>
                </FlexboxGrid>
              </List.Item>
            )}
            {showMore && (
              <List.Item key={8}>
                <FlexboxGrid
                  align="middle"
                  justify="space-between"
                  style={{ fontSize: '0.9em', flexWrap: 'nowrap', gap: '8px' }}
                >
                  <FlexboxGrid.Item style={{ flexShrink: 0 }}>
                    <Icon icon={IconInfo} color={COLOURS.default} style={{ width: 14, height: 14 }} />
                  </FlexboxGrid.Item>
                  <FlexboxGrid.Item
                    style={{
                      flexShrink: 1,
                      minWidth: 0,
                      overflow: 'hidden',
                      whiteSpace: 'nowrap',
                      textOverflow: 'ellipsis',
                    }}
                  >
                    {'IoVersion:' + theDevice.ioVersion}
                  </FlexboxGrid.Item>
                </FlexboxGrid>
              </List.Item>
            )}
            {showMore && (
              <List.Item key={9}>
                <FlexboxGrid
                  align="middle"
                  justify="space-between"
                  style={{ fontSize: '0.9em', flexWrap: 'nowrap', gap: '8px' }}
                >
                  <FlexboxGrid.Item style={{ flexShrink: 0 }}>
                    <Icon icon={IconInfo} color={COLOURS.default} style={{ width: 14, height: 14 }} />
                  </FlexboxGrid.Item>
                  <FlexboxGrid.Item
                    style={{
                      flexShrink: 1,
                      minWidth: 0,
                      overflow: 'hidden',
                      whiteSpace: 'nowrap',
                      textOverflow: 'ellipsis',
                    }}
                  >
                    {'Exp 1 Version:' + theDevice.exp1Version}
                  </FlexboxGrid.Item>
                </FlexboxGrid>
              </List.Item>
            )}
            {showMore && (
              <List.Item key={10}>
                <FlexboxGrid
                  align="middle"
                  justify="space-between"
                  style={{ fontSize: '0.9em', flexWrap: 'nowrap', gap: '8px' }}
                >
                  <FlexboxGrid.Item style={{ flexShrink: 0 }}>
                    <Icon icon={IconInfo} color={COLOURS.default} style={{ width: 14, height: 14 }} />
                  </FlexboxGrid.Item>
                  <FlexboxGrid.Item
                    style={{
                      flexShrink: 1,
                      minWidth: 0,
                      overflow: 'hidden',
                      whiteSpace: 'nowrap',
                      textOverflow: 'ellipsis',
                    }}
                  >
                    {'Exp 2 Version:' + theDevice.exp2Version}
                  </FlexboxGrid.Item>
                </FlexboxGrid>
              </List.Item>
            )}
            {showMore && (
              <List.Item key={11}>
                <FlexboxGrid
                  align="middle"
                  justify="space-between"
                  style={{ fontSize: '0.9em', flexWrap: 'nowrap', gap: '8px' }}
                >
                  <FlexboxGrid.Item style={{ flexShrink: 0 }}>
                    <Icon icon={IconInfo} color={COLOURS.default} style={{ width: 14, height: 14 }} />
                  </FlexboxGrid.Item>
                  <FlexboxGrid.Item
                    style={{
                      flexShrink: 1,
                      minWidth: 0,
                      overflow: 'hidden',
                      whiteSpace: 'nowrap',
                      textOverflow: 'ellipsis',
                    }}
                  >
                    {'Chem Version:' + theDevice.chemVersion}
                  </FlexboxGrid.Item>
                </FlexboxGrid>
              </List.Item>
            )}
          </List>
        </FlexboxGrid.Item>
      </FlexboxGrid>
      <div className="text-center" style={{ marginTop: '12px' }}>
        <FlexboxGrid justify="space-around" align="middle" style={{ marginTop: '12px' }}>
          <FlexboxGrid.Item className="gap-2">
            <ButtonToolbar>
              <Whisper placement="top" trigger="hover" speaker={<Tooltip>Edit This Device info</Tooltip>}>
                <IconButton
                  appearance="primary"
                  color="blue"
                  size="sm"
                  icon={<IconEdit />}
                  onClick={() => onEditDevice(theDevice)}
                  aria-label={`Edit ${theDevice.userName || theDevice.uniqueDeviceId}`}
                />
              </Whisper>
              <Whisper placement="top" trigger="hover" speaker={<Tooltip>Select This Device</Tooltip>}>
                <IconButton
                  appearance="primary"
                  color="blue"
                  size="sm"
                  icon={<IconPoint />}
                  onClick={() => onViewDevice(theDevice.uniqueDeviceId)}
                  aria-label={`Select ${theDevice.userName || theDevice.uniqueDeviceId}`}
                />
              </Whisper>

              <Whisper placement="top" trigger="hover" speaker={<Tooltip>Show the QR Code for this Device.</Tooltip>}>
                <IconButton
                  appearance="primary"
                  color="blue"
                  size="sm"
                  icon={<IconQRCode />}
                  onClick={() => onShowQRCode(theDevice)}
                  aria-label={`Show QR code for ${theDevice.userName || theDevice.uniqueDeviceId}`}
                />
              </Whisper>
              <Whisper placement="top" trigger="hover" speaker={<Tooltip>Archive this Device.</Tooltip>}>
                <IconButton
                  appearance="primary" //{theDevice.archived ?  "primary" : 'default' }
                  color="blue"
                  size="sm"
                  icon={theDevice.archived ? <IconArchive /> : <IconArchive2 />}
                  // icon={theDevice.archived ? <IconTicked /> : <IconUnticked />}
                  onClick={() => onArchiveDevice(theDevice)}
                  aria-label={`${theDevice.archived ? 'Unarchive' : 'Archive'} ${theDevice.userName || theDevice.uniqueDeviceId}`}
                ></IconButton>
              </Whisper>

              {accessLevel !== accessLevels.service && accessLevel !== accessLevels.super && (
                <Whisper placement="top" trigger="hover" speaker={<Tooltip>Delete this Device.</Tooltip>}>
                  <IconButton
                    appearance="primary"
                    color="blue"
                    size="sm"
                    icon={<IconRubbish />}
                    onClick={() => onDeleteDevice(theDevice)}
                    aria-label={`Delete ${theDevice.userName || theDevice.uniqueDeviceId}`}
                  ></IconButton>
                </Whisper>
              )}
            </ButtonToolbar>
          </FlexboxGrid.Item>
        </FlexboxGrid>
      </div>
    </Card>
  );
};

export const HomeView = (props) => {
  const { accessLevel, loginId } = useAuthContext();
  const [showAddDevice, setShowAddDevice] = useState(false);
  const [showInfoDevice, setShowAddDeviceInfoRecord] = useState(false);
  const [showEditDevice, setShowEditDevice] = useState(false);
  const [showQRCode, setShowQRCode] = useState(false);
  const [showConfirmDelete, setShowConfirmDelete] = useState(false);
  const [deviceToEdit, setDeviceToEdit] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [numPerPage, setNumPerPage] = useState(20);
  const [showStatsList, setShowStatsList] = useState(false);
  const [fixed, setFixed] = useState(false);

  // The Cascader filter dropdowns lay their drill-down columns out side by
  // side (width = levels * columnWidth) with no built-in responsive shrink,
  // so on a narrow phone viewport a 3-level-deep menu (Status -> Fault -> ...)
  // overflows off-screen. Narrow the columns on small screens instead.
  const [isNarrowViewport, setIsNarrowViewport] = useState(
    () => typeof window !== 'undefined' && window.innerWidth <= 480,
  );
  useEffect(() => {
    if (typeof window.matchMedia !== 'function') return undefined;
    const mql = window.matchMedia('(max-width: 480px)');
    const handleChange = (e) => setIsNarrowViewport(e.matches);
    // Older Safari (<14) only implements the deprecated addListener/
    // removeListener pair — MediaQueryList has no addEventListener there.
    if (typeof mql.addEventListener === 'function') {
      mql.addEventListener('change', handleChange);
      return () => mql.removeEventListener('change', handleChange);
    }
    mql.addListener(handleChange);
    return () => mql.removeListener(handleChange);
  }, []);

  const isDeviceSelected = (device) =>
    props.selectedDevices.length === 0 || props.selectedDevices.includes(device.uniqueDeviceId);

  const isDeviceFaultSelected = (device, filter) =>
    (filter === FILTER_OPTIONS.statusDeviceFaultsAny && isDeviceInFault(device)) ||
    (filter === FILTER_OPTIONS.statusDeviceFaultsInternalCommsIssue &&
      (device.currentFaults & faults_bit_t.FAULT_INTERNAL_COMMS_BIT) === faults_bit_t.FAULT_INTERNAL_COMMS_BIT) ||
    (filter === FILTER_OPTIONS.statusDeviceFaultsTherm1ShortCircuit &&
      (device.currentFaults & faults_bit_t.FAULT_THERMISTOR_1_SHORT_BIT) ===
        faults_bit_t.FAULT_THERMISTOR_1_SHORT_BIT) ||
    (filter === FILTER_OPTIONS.statusDeviceFaultsTherm1OpenCircuit &&
      (device.currentFaults & faults_bit_t.FAULT_THERMISTOR_1_OPEN_BIT) === faults_bit_t.FAULT_THERMISTOR_1_OPEN_BIT) ||
    (filter === FILTER_OPTIONS.statusDeviceFaultsTherm2ShortCircuit &&
      (device.currentFaults & faults_bit_t.FAULT_THERMISTOR_2_SHORT_BIT) ===
        faults_bit_t.FAULT_THERMISTOR_2_SHORT_BIT) ||
    (filter === FILTER_OPTIONS.statusDeviceFaultsTherm2OpenCircuit &&
      (device.currentFaults & faults_bit_t.FAULT_THERMISTOR_2_OPEN_BIT) === faults_bit_t.FAULT_THERMISTOR_2_OPEN_BIT) ||
    (filter === FILTER_OPTIONS.statusDeviceFaultsPumpCommunicationsFault &&
      (device.currentFaults & faults_bit_t.FAULT_PUMP_COMMS_FAULT_BIT) === faults_bit_t.FAULT_PUMP_COMMS_FAULT_BIT) ||
    (filter === FILTER_OPTIONS.statusDeviceFaultsExpansion1Fault &&
      (device.currentFaults & faults_bit_t.FAULT_SLAVE1_COMMS_FAULT_BIT) ===
        faults_bit_t.FAULT_SLAVE1_COMMS_FAULT_BIT) ||
    (filter === FILTER_OPTIONS.statusDeviceFaultsExpansion2Fault &&
      (device.currentFaults & faults_bit_t.FAULT_SLAVE2_COMMS_FAULT_BIT) ===
        faults_bit_t.FAULT_SLAVE2_COMMS_FAULT_BIT) ||
    (filter === FILTER_OPTIONS.statusDeviceFaultsAmbientTemperatureFault &&
      (device.currentFaults & faults_bit_t.FAULT_AMBIENT_TEMPERATURE_BIT) ===
        faults_bit_t.FAULT_AMBIENT_TEMPERATURE_BIT) ||
    (filter === FILTER_OPTIONS.statusDeviceFaultsPhOrpExpansionFault &&
      (device.currentFaults & faults_bit_t.FAULT_SLAVE3_COMMS_FAULT_BIT) ===
        faults_bit_t.FAULT_SLAVE3_COMMS_FAULT_BIT) ||
    (filter === FILTER_OPTIONS.statusDeviceFaultsTherm3ShortCircuit &&
      (device.currentFaults & faults_bit_t.FAULT_THERMISTOR_3_SHORT_BIT) ===
        faults_bit_t.FAULT_THERMISTOR_3_SHORT_BIT) ||
    (filter === FILTER_OPTIONS.statusDeviceFaultsTherm3OpenCircuit &&
      (device.currentFaults & faults_bit_t.FAULT_THERMISTOR_3_OPEN_BIT) === faults_bit_t.FAULT_THERMISTOR_3_OPEN_BIT) ||
    (filter === FILTER_OPTIONS.statusDeviceFaultsCRCError &&
      (device.currentFaults & faults_bit_t.FAULT_CRC_FAULT) === faults_bit_t.FAULT_CRC_FAULT) ||
    (filter === FILTER_OPTIONS.statusDeviceFaultsCRC2Error &&
      (device.currentFaults & faults_bit_t.FAULT_CRC_2_FAULT) === faults_bit_t.FAULT_CRC_2_FAULT);

  const isDeviceStatusSelected = (device, filter) =>
    isDeviceFaultSelected(device, filter) ||
    (filter === FILTER_OPTIONS.statusDeviceOffline &&
      isDeviceOfflineWithinDateRange(device, props.selectedFilterDateRange)) ||
    (filter === FILTER_OPTIONS.statusDeviceInFault && isDeviceInFault(device)) ||
    (filter === FILTER_OPTIONS.statusDeviceGood && isDeviceGood(device));

  const isVersionSelected = (device, filter) => {
    let result = false;
    if (filter === FILTER_OPTIONS.versionUnknown) {
      result = device.versionNumber === 'NOT SET';
    } else if (filter === FILTER_OPTIONS.versionBeta) {
      if (device.versionNumber) {
        let buildNumber = ExtractString(device.versionNumber, 'B');

        // var buildNumber = device.versionNumber.slice(-2);
        // console.log( "Build NUmber", buildNumber);
        if (Number(buildNumber) > 60) {
          result = true;
        }
      }
    } else {
      const index = filter - FILTER_OPTIONS.version115B14;
      if (index >= 0 && index < FIRMWARE_VERSIONS.length) {
        const desc = FIRMWARE_VERSIONS[index].name;
        result = desc === device.versionNumber;
      }
    }
    return result;
  };

  const isFilterSelected = (device) => {
    let result = false;

    if (props.selectedFilter === null && props.selectedModelFilter === null) {
      result = true;
    } else if (props.selectedFilter !== null) {
      if (isDeviceStatusSelected(device, props.selectedFilter) || isVersionSelected(device, props.selectedFilter)) {
        if (props.selectedModelFilter === null || isModelTypeSelected(device, props.selectedModelFilter)) {
          result = true;
        }
      }
    } else if (isModelTypeSelected(device, props.selectedModelFilter)) {
      result = true;
    }
    return result;
  };

  // Archived visibility is applied once here (not per-view) so Grid's pagination
  // math and List's rows stay consistent with what's actually shown. Stats is
  // unaffected since StatsView renders from props.devicesStats, not this list.
  const isArchivedVisible = (device) =>
    device.archived === false || (device.archived === true && props.showArchivedDevices);
  const filteredDevices = props.devices
    .filter((device) => isDeviceSelected(device))
    .filter((device) => isFilterSelected(device))
    .filter((device) => isArchivedVisible(device));
  const totalPages = Math.ceil(filteredDevices.length / numPerPage);
  const allDevices = usePagination(filteredDevices, numPerPage);
  // currentPage is separate state from usePagination's own internal page —
  // clamp it the same way, so the Pagination control and row numbers stay
  // consistent with what allDevices.currentData() actually renders once
  // filteredDevices shrinks (archived toggle, filter change, ...).
  const effectiveCurrentPage = Math.min(currentPage, Math.max(1, totalPages));

  const handleAddDevice = async (result) => {
    setShowAddDevice(false);
    devLog('Added device', result);
    if (result !== null) {
      const { id, devType, usersDevName } = result;

      // handleAddDevice
      await props.onUpdateUserDeviceName(id, usersDevName, devType);
      props.onRefresh();
    }
  };

  const handleDeviceDeleteUpdate = (result) => {
    setShowConfirmDelete(false);

    if (result !== null) {
      const { id } = result;
      let recordID = getRecordIDFromUID(id);
      devLog('removing device access record', recordID, id);

      deleteAccessRecord(recordID, loginId);
    }
  };

  const handleSetSHowArchivedDevices = (value, checked) => {
    props.onToggleArchivedDevices(checked);
    devLog('setting Archived Visible', props.showArchivedDevices, value, checked);
  };

  const handleAddDeviceInfo = (result) => {
    setShowAddDeviceInfoRecord(false);
    if (result !== null) {
      const { id, name, modeltype } = result;
      createInfoRecord(id, name, modeltype);
      devLog('Add device Info: name changed', id, name, modeltype);
    }
  };

  const handleShowStatsList = () => setShowStatsList(!showStatsList);

  const handleEditDeviceShow = (device) => {
    setDeviceToEdit(device);
    setShowEditDevice(true);
  };

  const handleQRCodeShow = (device) => {
    setDeviceToEdit(device);
    setShowQRCode(true);
  };

  const handleDeleteRecord = (device) => {
    setDeviceToEdit(device);
    setShowConfirmDelete(true);
  };

  const doHandleEditDeviceUpdate = (device, name, userDevName, modeltype) => {
    setShowEditDevice(false);
    handleEditDeviceUpdate(
      device,
      name,
      userDevName,
      modeltype,
      props.onUpdateDeviceName,
      props.onUpdateUserDeviceName,
    );
  };

  const handleArchiveRecord = (device) => {
    setDeviceToEdit(device);
    devLog('canged Archived Toggle', device);
    updateDeviceArchivedStatus(device.uniqueDeviceId, !device.archived);
  };

  const handlePageChange = (newPage, prevPage) => {
    devLog('handlePageChange: ', prevPage, ' -> ', newPage);
    setCurrentPage(newPage);
    allDevices.jump(newPage);
  };

  const onNumPerPageChanged = (value) => {
    setNumPerPage(value);
    if (currentPage !== 1) {
      handlePageChange(1, currentPage);
    }
  };

  async function updateDeviceArchivedStatus(deviceId, archived) {
    let record_ID = getRecordIDFromUID(deviceId);
    try {
      const result = await client.graphql({
        query: updateDevice,
        variables: {
          input: {
            recordType: RECORD_TYPES.INFO,
            recordID: record_ID,
            archived: archived === true ? 'archived' : 'not archived',
          },
        },
      });

      if ('data' in result && result.data?.updateDevice) {
        props.onUpdateDeviceLocalArchiveStatus(deviceId, result.data.updateDevice.archived === 'archived');
        devLog('updating archived status:', result, result.data.updateDevice.archived);
      } else {
        devLog('updateDeviceArchivedStatus: unexpected response', result);
      }
    } catch (error) {
      console.error('updateDeviceArchivedStatus failed:', error);
    }
  }

  const getRowNumber = (index) => {
    return (effectiveCurrentPage - 1) * numPerPage + index;
  };

  const handleQRDeviceUpdate = () => {
    setShowQRCode(false);
  };

  const onSelectedFilterChanged = (value) => {
    props.onSelectedFilterChanged(value);
  };

  // Status/Version options for the second picker. The old "Model" branch here
  // was broken (it set selectedFilter to a model value nothing matched) and
  // duplicated the dedicated Model picker, so it is excluded.
  const statusVersionFilterData = getFilterOptionsData().filter((o) => o.value !== FILTER_OPTIONS.modelTypeGroup);

  async function addDevice(deviceId, name, loginId, devType) {
    // if (props.userGroups.length !== 0) {
    let record_ID = getRecordIDFromUID(deviceId);
    var deviceText = 'Unknown';
    if (devType !== undefined) {
      deviceText = getControllerIconText(devType).Text;
    }
    devLog('addDevice:', record_ID, 'type', deviceText);
    let result;

    try {
      result = await client.graphql({
        query: createDevice,
        variables: {
          input: {
            recordType: RECORD_TYPES.ACCESS + loginId,
            recordID: record_ID,
            userName: name,
          },
        },
      });
    } catch (err) {
      devLog('Error Adding a Device', err);
      return err;
    }
    devLog('add:', result);
    props.onRefresh();
    // }
  }

  async function deleteAccessRecord(record_ID, userId) {
    const result = await client.graphql({
      query: deleteDevice,
      variables: {
        input: {
          recordType: RECORD_TYPES.ACCESS + userId,
          recordID: record_ID,
        },
      },
    });
    devLog('Deleting access record', record_ID, result);
    props.onRefresh();
  }

  async function createInfoRecord(deviceId, name, type) {
    let record_ID = getRecordIDFromUID(deviceId);

    devLog(' createInfoRecord name :', record_ID, name, type);
    const result = await client.graphql({
      query: createDevice,
      variables: {
        input: {
          recordType: RECORD_TYPES.INFO,
          recordID: record_ID,
          userName: name,
          modelType: type,
        },
      },
    });
    devLog('info record created:', result);
    props.onRefresh();
    return result;
  }

  const elementStyle = {
    zIndex: 2011,
  };

  return (
    <div className="gap-2 space-y-4">
      <Affix onChange={(affixed) => setFixed(affixed ?? false)}>
        <Grid
          numItemsSm={2}
          numItemsMd={2}
          numItemsLg={4}
          className="gap-2"
          style={fixed ? fixedHeaderCardStyle : unfixedHeaderCardStyle}
        >
          <Col>
            <ButtonToolbar>
              <Button
                appearance="primary"
                color="blue"
                endIcon={<IconRefresh />}
                size="sm"
                loading={props.loading}
                onClick={props.onRefresh}
              >
                Refresh
              </Button>
              {props.loading === false && (
                <>
                  <Button appearance="primary" color={'blue'} size="sm" onClick={() => setShowAddDevice(true)}>
                    Add a Device{' '}
                  </Button>
                  {accessLevel === accessLevels.super && (
                    <Button
                      appearance="primary"
                      color={'blue'}
                      size="sm"
                      onClick={() => setShowAddDeviceInfoRecord(true)}
                    >
                      Add Info Record
                    </Button>
                  )}
                </>
              )}
            </ButtonToolbar>
          </Col>
          {props.loading === false && (
            <Col numColSpanLg={3}>
              <div
                className="my-element"
                style={{ ...elementStyle, display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 12 }}
              >
                {(props.selectedView === selectedView_t.GRID || props.selectedView === selectedView_t.LIST) && (
                  <>
                    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
                      Filter
                      <Cascader
                        popupStyle={{ zIndex: 1023 }}
                        data={getModelFilterOptionsData()}
                        columnWidth={isNarrowViewport ? 100 : 140}
                        columnHeight={144}
                        onChange={(value) => props.onSelectedModelFilterChanged(value)}
                        placeholder="Model"
                        searchable={false}
                        size="md"
                        value={props.selectedModelFilter}
                      />
                      <Cascader
                        popupStyle={{ zIndex: 1023 }}
                        data={statusVersionFilterData}
                        columnWidth={isNarrowViewport ? 120 : 180}
                        columnHeight={144}
                        onChange={(value) => onSelectedFilterChanged(value)}
                        placeholder="Status / Version"
                        searchable={false}
                        size="md"
                        value={props.selectedFilter}
                      />
                    </span>

                    {props.selectedFilter === FILTER_OPTIONS.statusDeviceOffline && (
                      <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
                        Date
                        <SelectDateRange
                          range={props.selectedFilterDateRange}
                          cleanable={true}
                          maxDays={60}
                          onChange={props.onSelectedDateRangeChanged}
                          style={headingStyle}
                        />
                      </span>
                    )}
                  </>
                )}

                {(props.selectedView === selectedView_t.GRID || props.selectedView === selectedView_t.LIST) && (
                  <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6, whiteSpace: 'nowrap' }}>
                    Show Archived
                    <Checkbox
                      checked={props.showArchivedDevices}
                      value={12}
                      color="blue"
                      onChange={handleSetSHowArchivedDevices}
                    ></Checkbox>
                  </span>
                )}

                {props.selectedView === selectedView_t.GRID && (
                  <SelectItemsPerPage
                    totalItems={filteredDevices.length}
                    itemsPerPage={numPerPage}
                    onChange={onNumPerPageChanged}
                  />
                )}

                <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6, marginLeft: 'auto' }}>
                  Display
                  <TabGroup
                    defaultIndex={props.selectedView}
                    onIndexChange={(value) => props.onSelectedViewChanged(value)}
                  >
                    {accessLevel === accessLevels.super ? (
                      <TabList variant="solid" color={COLOURS.default}>
                        <Tab>Grid</Tab>
                        <Tab>List</Tab>
                        <Tab>Stats</Tab>
                        {/* <Tab>Settings</Tab> */}
                      </TabList>
                    ) : accessLevel === accessLevels.service ? (
                      <TabList variant="solid" color={COLOURS.default}>
                        <Tab>Grid</Tab>
                        <Tab>List</Tab>
                        <Tab>Stats</Tab>
                      </TabList>
                    ) : (
                      <TabList variant="solid" color={COLOURS.default}>
                        <Tab>Grid</Tab>
                        <Tab>List</Tab>
                      </TabList>
                    )}
                  </TabGroup>
                </span>
              </div>
            </Col>
          )}
        </Grid>
      </Affix>

      {props.loading === true ? (
        <LoadingView progress={props.progress}></LoadingView>
      ) : props.selectedView === selectedView_t.GRID ? (
        <div>
          <Grid numItemsSm={1} numItemsMd={4} numItemsLg={4} className="gap-4">
            {allDevices.currentData().map((device, index) => {
              return (
                // Archived visibility is already applied once in filteredDevices above.
                <DeviceCard
                  theDevice={device}
                  rowNumber={getRowNumber(index + 1)}
                  accessLevel={accessLevel}
                  onEditDevice={handleEditDeviceShow}
                  onViewDevice={props.onViewDevice}
                  onShowQRCode={handleQRCodeShow}
                  onArchiveDevice={handleArchiveRecord}
                  onDeleteDevice={handleDeleteRecord}
                  key={device.uniqueDeviceId}
                />
              );
            })}
          </Grid>
          {totalPages > 1 && (
            <div className="mt-3" style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Pagination
                prev
                next
                first
                last
                ellipsis
                boundaryLinks
                maxButtons={7}
                size="sm"
                total={filteredDevices.length}
                limit={numPerPage}
                activePage={effectiveCurrentPage}
                onChangePage={(newPage) => handlePageChange(newPage, currentPage)}
                className="table-pagination"
              />
            </div>
          )}
        </div>
      ) : props.selectedView === selectedView_t.STATS ? (
        <div>
          <StatsView
            stats={props.devicesStats}
            showList={showStatsList}
            loading={props.loading}
            progress={props.progress}
            onRefresh={props.onRefresh}
            onShowListChanged={handleShowStatsList}
          />
        </div>
      ) : props.selectedView === selectedView_t.LIST ? (
        <CollectionHooksTable
          devices={filteredDevices}
          onSelectionChange={props.onSelectedDevicesChanged}
          onViewDevice={props.onViewDevice}
          onQRCodeClick={handleQRCodeShow}
          onEditDevice={handleEditDeviceShow}
        />
      ) : (
        <div>
          <UserView
            stats={props.devicesStats}
            showList={showStatsList}
            loading={props.loading}
            progress={props.progress}
            onRefresh={props.onRefresh}
            onShowListChanged={handleShowStatsList}
          />
        </div>
      )}

      <AddDevice open={showAddDevice} handleClose={handleAddDevice} />
      <AddDeviceInfo open={showInfoDevice} handleClose={handleAddDeviceInfo} />
      <EditDevice open={showEditDevice} device={deviceToEdit} handleClose={doHandleEditDeviceUpdate} />
      <ShowDeviceQR open={showQRCode} device={deviceToEdit} handleClose={handleQRDeviceUpdate} />
      <ShowDeviceDeleteConfirmation
        open={showConfirmDelete}
        device={deviceToEdit}
        handleClose={handleDeviceDeleteUpdate}
      />
    </div>
  );
};
